// Add this at the very top of your file, before any other code
console.log('Script loaded');  // This will help verify the script is loading

// Method 1: pageshow event
window.addEventListener('pageshow', async function (event) {
  try {
    await BundleSettings();
    const selectedBoxVariant = document.querySelector('.purchase-flow-step_2__box-variants-selector__input:checked');
    if (selectedBoxVariant) {
      console.log('pageshow BoxVariants clicked');
      selectedBoxVariant.click();
      selectedBoxVariant.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const selectedBundlePageBoxOption = document.querySelector('.js-bundle-page-box-option-input:checked');
    if (selectedBundlePageBoxOption) {
      selectedBundlePageBoxOption.click();
      selectedBundlePageBoxOption.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } catch (error) {
    console.error('Error fetching bundle settings:', error);
  }


});

var allVariants = [];
var flowOBJ = { extras: [] };

var byobOBJ = { products: [] };

// Active dietary preference: 'standard' | 'no-meat' | 'no-nuts' | 'no-crackers'
var byobActivePreference = 'standard';
// Default delivery frequency (in weeks) preselected when the shopper hasn't
// chosen one. Matched against the week count parsed from the selling plan name.
var BYOB_DEFAULT_FREQ_WEEKS = 2;
// Track the step change with Klaviyo
var _learnq = window._learnq || [];

function getQueryParams(key) {
  const urlParams = new URLSearchParams(window.location.search);
  const queryParams = {};
  urlParams.forEach((value, key) => {
    queryParams[key] = value;
  });
  return queryParams[key];
}
console.log('recharge', recharge);

async function getBundleId(bundle) {
  try {
    console.log('bundle', bundle);
    const rb_id = await recharge.bundle.getBundleId(bundle);
    console.log('rb_id', rb_id);
    flowOBJ.rbId = rb_id;

    // Instead of calling addToCart directly, dispatch a custom event
    const event = new CustomEvent('bundleIdReceived');
    document.dispatchEvent(event);
  } catch (error) {
    console.error('Error fetching bundle ID:', error);
  }
}


// Fetch (and cache) the Recharge bundle settings for a specific box product.
// Used both on first load and every time the dietary preference switches the box
// to a different product/bundle. Skips the network call if we already hold the
// settings for that product.
async function loadBundleSettings(productId) {
  try {
    if (!productId) { return; }
    productId = String(productId);
    if (byobOBJ.bundleSettings && byobOBJ.bundleSettingsProductId === productId) {
      return byobOBJ.bundleSettings;
    }
    // Initialize ReCharge once - this is required before any recharge.* call.
    if (!window.__byobRechargeInited) {
      recharge.init({
        storeIdentifier: '504ac4.myshopify.com',
        appName: 'appName',
        appVersion: '1.0.0'
      });
      window.__byobRechargeInited = true;
    }
    const bundleSettings = await recharge.cdn.getCDNBundleSettings(productId);
    byobOBJ.bundleSettings = bundleSettings;
    byobOBJ.bundleSettingsProductId = productId;
    console.log('bundleSettings', productId, bundleSettings);
    return bundleSettings;
  } catch (error) {
    console.error('Error fetching bundle settings:', error);
  }
}

// Full-screen loader shown while a size/preference change re-fetches the bundle
// and reapplies its default item selections. A minimum visible time keeps the
// loader from flickering when the bundle settings are already cached.
var BYOB_LOADER_MIN_MS = 500;
var byobLoaderShownAt = 0;
var byobLoaderTimer = null;

function showByobLoader() {
  const el = document.getElementById('byob-loader');
  if (!el) { return; }
  if (byobLoaderTimer) { clearTimeout(byobLoaderTimer); byobLoaderTimer = null; }
  el.classList.add('is-visible');
  el.setAttribute('aria-hidden', 'false');
  document.body.classList.add('byob-loading');
  byobLoaderShownAt = Date.now();
}

function hideByobLoader() {
  const el = document.getElementById('byob-loader');
  if (!el) { return; }
  const elapsed = Date.now() - byobLoaderShownAt;
  const wait = Math.max(0, BYOB_LOADER_MIN_MS - elapsed);
  if (byobLoaderTimer) { clearTimeout(byobLoaderTimer); }
  byobLoaderTimer = setTimeout(function () {
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('byob-loading');
    byobLoaderTimer = null;
  }, wait);
}

async function BundleSettings() {
  const step1 = document.querySelector('.byob-step--1');
  const bundleProductID = step1 ? step1.getAttribute('data-box-product-id') : null;
  if (!bundleProductID) {
    console.log('No bundle product ID found');
    return;
  }
  return loadBundleSettings(bundleProductID);
}

document.addEventListener('DOMContentLoaded', async function () {
  console.log('DOMContentLoaded ya tyt');
  try {
    await BundleSettings();
    const selectedBoxVariant = document.querySelector('.purchase-flow-step_2__box-variants-selector__input:checked');
    if (selectedBoxVariant) {
      console.log('DOMContentLoaded BoxVariants clicked');
      selectedBoxVariant.click();
      selectedBoxVariant.dispatchEvent(new Event('change', { bubbles: true }));
      const frequencySelector = document.querySelector('input[name="frequency"]:checked');
      if (frequencySelector) {
        frequencySelector.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const selectedBundlePageBoxOption = document.querySelector('.js-bundle-page-box-option-input:checked');
    if (selectedBundlePageBoxOption) {
      selectedBundlePageBoxOption.click();
      selectedBundlePageBoxOption.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } catch (error) {
    console.error('Error fetching bundle settings:', error);
  }
});

byobOBJ.status = true;
document.addEventListener('DOMContentLoaded', function () {
  // console.log('DOMContentLoaded');
  flowOBJ.box_product_id = parseInt(document.querySelector('.byob-step--1').getAttribute('data-box-product-id'));
  const footerContinueButton = document.querySelector('#page-purchase-flow__footer-button--continue');
  const closePopupButton = document.getElementById('close-extra-products-popup');
  const popup = document.getElementById('extra-products-popup');
  const popupShow = popup ? popup.getAttribute('data-show') : false;
  const checkoutButton = document.getElementById('extra-products-popup__checkout-button');
  const checkoutSkipButton = document.getElementById('extra-products-popup__skip');

  if (closePopupButton) {
    closePopupButton.addEventListener('click', function () {
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
      document.documentElement.classList.remove('html-popup-open');
    });
  }


  if (checkoutButton) {
    checkoutButton.addEventListener('click', function () {
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Checking out...';
      flowOBJ.extras = [];
      const activeExtraProducts = document.querySelectorAll('.byob-step--4 .purchase-flow__product-card.active');
      if (activeExtraProducts.length > 0) {
        activeExtraProducts.forEach(product => {
          const productId = product.querySelector('[data-product-id]').getAttribute('data-variant-id');
          const quantity = parseInt(product.querySelector('.purchase-flow-step__quantity-selector input').value);
          const productName = product.querySelector('[data-product-name]').getAttribute('data-product-name');
          const productPrice = parseFloat(product.querySelector('[data-product-price]').getAttribute('data-product-price'));
          flowOBJ.extras.push({ product_id: parseInt(productId), quantity: quantity });

          // fbq('track', 'AddToCart', {
          //   value: (productPrice * quantity).toFixed(2),
          //   currency: 'USD',
          //   content_name: productName,
          //   content_type: 'product',
          //   contents: {
          //     id: productId,
          //     quantity: quantity
          //   }
          // });
        });
      }
      // addToCart();
      addToBundle();
    });
  }

  if (checkoutSkipButton) {
    checkoutSkipButton.addEventListener('click', function () {
      checkoutSkipButton.disabled = true;
      checkoutButton.disabled = true;
      addToBundle();
    });
  }


  // Close popup when clicking outside of it
  window.addEventListener('click', function (event) {
    if (event.target === popup) {
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
      document.documentElement.classList.remove('html-popup-open');
    }
    if (!event.target.closest('.byob-frequency-selector-dropdown')) {
      const byobFrequencySelectorDropdown = document.querySelector('input[name="byob-frequency-selector-dropdown"]');
      if (byobFrequencySelectorDropdown) {
        byobFrequencySelectorDropdown.checked = false;
      }
    }
  });

  footerContinueButton.addEventListener('click', function () {
    addBYOBtoArray();
    if (popupShow === 'true') {
      popup.style.display = 'block';
      document.body.classList.add('popup-open');
      document.documentElement.classList.add('html-popup-open');
      // facebook pixel add to cart event for subscription product
      // fbq('track', 'AddToCart', {
      //   value: flowOBJ.price.replace('$', ''),
      //   currency: 'USD',
      //   content_id: flowOBJ.box_variant_id,
      //   content_name: flowOBJ.variantName,
      //   contents: byobOBJ.products.map(product => {
      //     return {
      //       id: product.variant_id,
      //       name: product.product_name,
      //       quantity: product.quantity
      //     }
      //   }),
      //   content_type: 'product_group',
      // });

      const extrasAddOrderButton = document.querySelectorAll('.byob-step--4 [data-add-to-order]');
      if (extrasAddOrderButton.length > 0) {
        extrasAddOrderButton.forEach(button => {
          button.addEventListener('click', function () {
            checkoutButton.textContent = byob_flow_settings.footer_extra_products_added_text;
          });
        });
      }
    } else {
      footerContinueButton.disabled = true;
      footerContinueButton.textContent = 'Checking out...';
      // addToCart();
      addToBundle();
    }
  });

  const BoxVariants = document.querySelectorAll('.purchase-flow-step_2__box-variants-selector__input');

  BoxVariants.forEach(variant => {
    variant.addEventListener('change', function (event) {
      const variantJson = JSON.parse(this.getAttribute('data-json'));
      const price = this.getAttribute('data-price');
      const image = this.getAttribute('data-image');
      const compareAtPrice = parseFloat(price.replace('$', '')) < parseFloat(variantJson.price / 100) ? "$" + (variantJson.price / 100) : "$0";
      // console.log('variantJson', variantJson);
      var item = {
        "ProductName": variantJson.name,
        "ProductID": parseInt(variantJson.id),
        "SKU": variantJson.sku,
        "Categories": [],
        "ImageURL": variantJson.featured_image ? variantJson.featured_image.src : image,
        "URL": location.href,
        "Brand": "AppyHour",
        "Price": price,
        "CompareAtPrice": compareAtPrice
      };
      _learnq.push(["track", "Viewed Product", item]);
      // console.log('item', item);

      const variantId = parseInt(this.value);
      flowOBJ.box_variant_id = variantId;
      const boxSize = parseInt(this.getAttribute('data-box-size'));
      flowOBJ.price = price;
      flowOBJ.variantName = variantJson.name;
      flowOBJ.boxSize = boxSize;
      // updatePlanInfo(price, variantId);

      // Resolve to the active dietary preference's product/variant (or standard),
      // then rebuild frequency options, reload that bundle's settings and reapply
      // its default item selections. Handles both size changes and preference
      // changes through a single code path. Show the loader only for real user
      // size changes (event.isTrusted) — not the programmatic initial-load click.
      applyActivePreference(event && event.isTrusted);
      // console.log('step2BoxVariants Chage');

      // userSelectedBuildYourOwnBox(); // Call this function to set up or remove BYOB listeners
    });
  });

  // Parse the number of weeks from a selling-plan name, regardless of how the
  // product line phrases it ("Delivery Every 6 Weeks" or "6 week subscription").
  function freqWeeks(name) {
    const m = (name || '').match(/(\d+)\s*week/i);
    return m ? parseInt(m[1], 10) : null;
  }
  // Normalize the display label so every plan reads "Every N Weeks".
  function freqLabel(name) {
    const w = freqWeeks(name);
    return w ? ('Every ' + w + ' Week' + (w === 1 ? '' : 's')) : (name || '').replace('Delivery ', '').trim();
  }

  function updateFrequencyInfo(variantId) {
    const variant_info = allVariants.find(v => v.id === variantId);
    if (!variant_info || !variant_info.selling_plans || variant_info.selling_plans.length === 0) { return; }
    const frequencySelector = document.querySelector('.frequency-selector');
    if (!frequencySelector) { return; }
    const plans = variant_info.selling_plans;

    // Decide which plan to preselect:
    // 1. If the shopper has already picked a cadence, keep that cadence by its
    //    *week count* — plan names/IDs differ across dietary products, but the
    //    number of weeks is consistent, so we match on that.
    // 2. Otherwise fall back to the configured default (BYOB_DEFAULT_FREQ_WEEKS).
    // 3. Otherwise the first available plan.
    var activeIndex = -1;
    if (flowOBJ.__freqUserSelected && flowOBJ.__freqWeeks) {
      activeIndex = plans.findIndex(p => freqWeeks(p.Name) === flowOBJ.__freqWeeks);
    }
    if (activeIndex < 0) {
      activeIndex = plans.findIndex(p => freqWeeks(p.Name) === BYOB_DEFAULT_FREQ_WEEKS);
    }
    if (activeIndex < 0) { activeIndex = 0; }

    frequencySelector.innerHTML = '';
    flowOBJ.plan_type = 'payPerBox';

    plans.forEach((plan, index) => {
      const labelText = freqLabel(plan.Name);
      const weeks = freqWeeks(plan.Name);
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'frequency';
      input.id = `frequency-${plan.SellingPlanID}`;
      input.value = plan.SellingPlanID;
      input.setAttribute('data-frequency-name', labelText);
      input.setAttribute('data-frequency-weeks', weeks || '');

      input.addEventListener('change', handleFrequencyChange);

      if (index === activeIndex) {
        input.checked = true;
        flowOBJ.selling_plan_id = parseInt(plan.SellingPlanID);
        flowOBJ.__freqWeeks = weeks;
        flowOBJ.__freqName = labelText;
        // Keep the dropdown's summary value in sync with the preselected plan.
        const dropdownValue = document.querySelector('.byob-frequency-selector-dropdown__value');
        if (dropdownValue) { dropdownValue.textContent = labelText; }
      }

      frequencySelector.appendChild(input);

      const label = document.createElement('label');
      label.classList.add('frequency-selector__option');
      label.setAttribute('for', `frequency-${plan.SellingPlanID}`);
      label.textContent = labelText;
      frequencySelector.appendChild(label);
    });
  }

  function handleFrequencyChange(event) {
    flowOBJ.selling_plan_id = parseInt(event.target.value);
    // Remember the shopper's chosen cadence by its week count so it survives a
    // dietary product switch, which rebuilds the options with new plan IDs/names.
    flowOBJ.__freqUserSelected = true;
    const weeks = parseInt(event.target.getAttribute('data-frequency-weeks'));
    if (weeks) { flowOBJ.__freqWeeks = weeks; }
    const chosenName = event.target.getAttribute('data-frequency-name');
    if (chosenName) { flowOBJ.__freqName = chosenName; }

    const byobFrequencySelectorDropdown = document.querySelector('input[name="byob-frequency-selector-dropdown"]');
    if (byobFrequencySelectorDropdown) {
      byobFrequencySelectorDropdown.checked = false;
      const frequencyName = event.target.getAttribute('data-frequency-name');
      if (frequencyName) {
        const frequencySelectorDropdown = document.querySelector('.byob-frequency-selector-dropdown__value');
        frequencySelectorDropdown.textContent = frequencyName;
      }
    }

    if (typeof updateBoxSummary === 'function') { updateBoxSummary(); }
  }


  function updatePlanInfo(boxPrice, variantId) {
    var flowPlanPrice = boxPrice;
    if (!flowPlanPrice || !variantId) { return; }
    const variant_info = allVariants.find(v => v.id === variantId);
    const prePaidPriceElement = document.querySelector('.selection-pre-paid-price-value');
    const prePaidPriceElementOld = document.querySelector('.selection-pre-paid-price-value-old');
    const prePaidTotalPriceElement = document.querySelector('.selection-pre-paid-total-price-value');
    const payPerBoxPriceElement = document.querySelector('.selection-pay-per-box-price-value');
    const payPerBoxPriceElementOld = document.querySelector('.selection-pay-per-box-price-value-old');
    const variant_price = variant_info.price;
    const price_prepaid = parseFloat(variant_info.prepaid[0].Price.replace('$', '')) / 3;
    const price_per_box = variant_info.payPerBox[0].Price;
    prePaidPriceElement.textContent = flowPlanPrice;

    // console.log('variant_price', variant_price);
    // console.log('price_prepaid', price_prepaid);
    // console.log('price_per_box', price_per_box);

    if (parseFloat(variant_price.replace('$', '')) > (price_prepaid)) {
      prePaidPriceElementOld.textContent = variant_price;
      prePaidPriceElement.textContent = '$' + price_prepaid.toFixed(0);
      prePaidTotalPriceElement.textContent = variant_info.prepaid[0].Price
    } else {
      prePaidPriceElementOld.textContent = '';
      prePaidPriceElement.textContent = variant_price;
      prePaidTotalPriceElement.textContent = '$' + (parseFloat(variant_price.replace('$', '')) * 3).toFixed(0);
    }

    if (parseFloat(variant_price.replace('$', '')) > parseFloat(price_per_box.replace('$', ''))) {
      payPerBoxPriceElementOld.textContent = variant_price;
      payPerBoxPriceElement.textContent = price_per_box;
    } else {
      payPerBoxPriceElementOld.textContent = '';
      payPerBoxPriceElement.textContent = variant_price;
    }

    // 
    // console.log('variantId', variantId);



    const planSelectionBoxes = document.querySelectorAll('.purchase-flow-step_3__plan-selection-box');
    planSelectionBoxes.forEach(box => {
      const planType = box.getAttribute('data-type');
      const planSellingPlanId = box.getAttribute('data-selling-plan-id');
      if (planType === 'prepaid') {
        box.setAttribute('data-selling-plan-id', variant_info.prepaid[0].SellingPlanID);
        flowOBJ.box_variant_id = variantId;
        if (box.classList.contains('active')) {
          flowOBJ.plan_type = 'prepaid';
          flowOBJ.selling_plan_id = parseInt(variant_info.prepaid[0].SellingPlanID);
        }
      } else if (planType === 'payPerBox') {
        box.setAttribute('data-selling-plan-id', variant_info.payPerBox[0].SellingPlanID);
        flowOBJ.box_variant_id = variantId;
        if (box.classList.contains('active')) {
          flowOBJ.plan_type = 'payPerBox';
          flowOBJ.selling_plan_id = parseInt(variant_info.payPerBox[0].SellingPlanID);
        }

        const deliveryFrequencyDropdown = box.querySelector('.purchase-flow-custom-dropdown');
        const customDropdownSelected = deliveryFrequencyDropdown.querySelector('.purchase-flow-custom-dropdown__selected');
        const customDropdownOptions = deliveryFrequencyDropdown.querySelector('.purchase-flow-custom-dropdown__options');

        if (deliveryFrequencyDropdown && variant_info.payPerBox.length > 0) {
          // Clear existing options
          customDropdownOptions.innerHTML = '';

          // Add new options
          variant_info.payPerBox.forEach(plan => {
            const option = document.createElement('div');
            option.classList.add('purchase-flow-custom-dropdown__option');
            option.setAttribute('data-value', plan.SellingPlanID);
            option.textContent = plan.Name;
            customDropdownOptions.appendChild(option);
          });

          const payPerBoxDeliveryFrequencyName = box.querySelector('.pay-per-box-delivery-frequency-name');

          // Remove existing event listeners
          const oldOptionClickHandler = deliveryFrequencyDropdown.optionClickHandler;
          const oldToggleDropdown = deliveryFrequencyDropdown.toggleDropdown;
          const oldCloseDropdown = deliveryFrequencyDropdown.closeDropdown;

          if (oldOptionClickHandler) customDropdownOptions.removeEventListener('click', oldOptionClickHandler);
          if (oldToggleDropdown) customDropdownSelected.removeEventListener('click', oldToggleDropdown);
          if (oldCloseDropdown) document.removeEventListener('click', oldCloseDropdown);

          // Set up new event listeners
          deliveryFrequencyDropdown.optionClickHandler = function (event) {
            if (event.target.classList.contains('purchase-flow-custom-dropdown__option')) {
              const selectedValue = event.target.getAttribute('data-value');
              const selectedText = event.target.textContent;
              const parentBox = event.target.closest('.purchase-flow-step_3__plan-selection-box');
              parentBox.click();
              customDropdownSelected.textContent = selectedText;
              payPerBoxDeliveryFrequencyName.textContent = selectedText;
              flowOBJ.selling_plan_id = parseInt(selectedValue);
              box.setAttribute('data-selling-plan-id', selectedValue);

              // console.log('Selected option:', selectedText);
              // console.log('flowOBJ', flowOBJ);

              deliveryFrequencyDropdown.classList.remove('open');
            }
          };

          deliveryFrequencyDropdown.toggleDropdown = function (event) {
            event.preventDefault();
            event.stopPropagation();
            deliveryFrequencyDropdown.classList.toggle('open');
          };

          deliveryFrequencyDropdown.closeDropdown = function (event) {
            if (!deliveryFrequencyDropdown.contains(event.target)) {
              deliveryFrequencyDropdown.classList.remove('open');
            }
          };

          customDropdownOptions.addEventListener('click', deliveryFrequencyDropdown.optionClickHandler);
          customDropdownSelected.addEventListener('click', deliveryFrequencyDropdown.toggleDropdown);
          document.addEventListener('click', deliveryFrequencyDropdown.closeDropdown);

          // Set initial value
          if (variant_info.payPerBox.length > 0) {
            const initialPlan = variant_info.payPerBox[0];
            customDropdownSelected.textContent = initialPlan.Name;
            payPerBoxDeliveryFrequencyName.textContent = initialPlan.Name;
            flowOBJ.selling_plan_id = parseInt(initialPlan.SellingPlanID);
            box.setAttribute('data-selling-plan-id', initialPlan.SellingPlanID);
          }
        }
      }
    });
    // console.log('flowOBJ', flowOBJ);
  }


  const planSelectionBoxes = document.querySelectorAll('.purchase-flow-step_3__plan-selection-box');

  planSelectionBoxes.forEach(box => {
    box.addEventListener('click', function () {

      planSelectionBoxes.forEach(box => {
        box.classList.remove('active');
      });
      this.classList.add('active');
      const boxType = this.getAttribute('data-type');
      const boxSellingPlanId = parseInt(this.getAttribute('data-selling-plan-id')) ? parseInt(this.getAttribute('data-selling-plan-id')) : parseInt(this.querySelector('.purchase-flow-step_3__plan-selection-box-content-delivery-frequency-dropdown').value);
      if (boxSellingPlanId) {
        flowOBJ.selling_plan_id = boxSellingPlanId;
        flowOBJ.plan_type = boxType;
        // console.log('flowOBJ', flowOBJ);
      }
      const planSelectionType = document.querySelector('.purchase-flow-step_3__plan-selection input[name="plan_type"]');

      planSelectionType.value = boxType;
    });
  });

  // Delivery Date
  const calendarEnabled = document.querySelector('#delivery-date-input-checkbox').getAttribute('data-calendar-enabled') === 'true' ? true : false;
  if (calendarEnabled) {
    const selectedOption = document.querySelector('.purchase-flow-step_3__plan-selection-delivery-dropdown-label');
    // const customDates = document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates') ? JSON.parse(document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates')) : [];
    const customDates = document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates') ? JSON.parse(document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates')) : [];
    let enableDates = [];
    const today = new Date();
    console.log('customDates', customDates);
    if (customDates && customDates.length > 0) {

      enableDates = customDates
        .filter(dateRange => {
          if (dateRange.shipping_date_expires && dateRange.shipping_date_expires !== '') {
            const cutOffDate = new Date(dateRange.shipping_date_expires);
            const today = new Date();
            // console.log('dateRange.shipping_date_expires', dateRange.shipping_date_expires, today);
            return cutOffDate >= today;
          } else {

            const shippingDate = new Date(dateRange.shipping_date + 'T00:00:00');
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            // console.log('dateRange.shipping_date', dateRange.shipping_date, today);
            return shippingDate >= today;
          }
        })
        .map(dateRange => ({
          from: new Date(dateRange.delivery_start_date + 'T00:00:00'),
          to: new Date(dateRange.delivery_end_date + 'T23:59:59'),
          shipping_date_expires: dateRange.shipping_date_expires
        }));
    } else {
      console.log('no custom dates');
      const cutOffDate = new Date(today);
      enableDates = Array.from({ length: 12 }, (_, i) => {
        // Create date in local timezone
        const startDate = new Date(today);
        startDate.setHours(0, 0, 0, 0);
        // console.log('startDate', startDate);

        // If current day is after Monday and time is after 9am, move to next week
        if (cutOffDate.getDay() >= 1 && cutOffDate.getHours() > 8) {
          startDate.setDate(startDate.getDate() + 7);
        }

        // Find next Tuesday
        startDate.setDate(startDate.getDate() + ((2 + 7 - startDate.getDay()) % 7) + (i * 7));
        startDate.setHours(0, 0, 0, 0);
        // console.log('startDate', startDate);

        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 3); // Friday is 2 days after Tuesday

        // Create ISO strings but preserve the local dates

        endDate.setHours(23, 59, 59, 999);

        return {
          from: startDate,
          to: endDate,
          shipping_date_expires: null
        };
      });
    }
    console.log('enableDates', enableDates);

    const firstValidRange = enableDates.find(range => range.from != null && range.to != null);
    const defaultDate = firstValidRange ? [
      new Date(firstValidRange.from),
      new Date(firstValidRange.to)
    ] : null;
    console.log('defaultDate', defaultDate);
    console.log('firstValidRange', firstValidRange);
    const calendar = flatpickr("#delivery-date-input", {
      mode: "range",
      dateFormat: "F j, Y",
      appendTo: document.getElementById('calendar-container'),
      static: true,
      inline: true,
      // minDate: new Date(today.setHours(0, 0, 0, 0)),
      minDate: enableDates.length > 0 ? enableDates[0].from : null,
      maxDate: enableDates.length > 0 ? new Date(enableDates[enableDates.length - 1].to.getTime() + 24 * 60 * 60 * 1000) : null,
      firstDayOfWeek: 0,
      enable: [
        function (date) {
          // Only allow Wednesday (3), Thursday (4), or Friday (5)
          // if (!customDates || customDates.length === 0) {
          //   console.log('date', date);
          //   if (date.getDay() !== 3 && date.getDay() !== 4 && date.getDay() !== 5) {
          //     return false;
          //   }
          // }

          // Check if the date falls within any of our enabled ranges
          return enableDates.some(range =>
            date >= range.from && date <= range.to
          );
        }
      ],
      defaultDate: defaultDate,
      onChange: function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) {
          console.log('selectedDates', selectedDates);
          // Find the matching range for the selected date
          const date = selectedDates[0];
          const matchingRange = enableDates.find(range =>
            date >= range.from && date <= range.to
          );
          console.log('matchingRange', matchingRange);

          if (matchingRange) {
            instance.setDate([matchingRange.from, matchingRange.to], true);
          } else {
            instance.clear();
          }
        } else if (selectedDates.length === 2) {
          const startDate = selectedDates[0];
          const endDate = selectedDates[1];

          // Find matching range that contains both dates
          const matchingRange = enableDates.find(range =>
            startDate >= range.from && endDate <= range.to
          );

          if (!matchingRange) {
            instance.clear();
          } else {
            selectedOption.textContent = formatDateRange(startDate, endDate);
            document.querySelector('.item--first-delivery-value').textContent = selectedOption.textContent;
            flowOBJ.first_delivery_window = selectedOption.textContent;
            const calendarShipDate = new Date(startDate);
            // Find the Monday before the delivery date (which is 3 days before)
            const daysToMonday = ((calendarShipDate.getDay() + 7) - 1) % 7;
            calendarShipDate.setDate(calendarShipDate.getDate() - daysToMonday);
            const calendar_ship = formatYYYYMMDD(calendarShipDate);
            document.querySelector('.item--first-delivery-value').setAttribute('data-ship', calendar_ship);
            flowOBJ._SHIP = calendar_ship;
            document.querySelector('#delivery-date-input-checkbox').checked = false;
            if (document.getElementById('countdown-timer')) {

              const shippingExpiresDate = new Date(matchingRange.shipping_date_expires);
              if (shippingExpiresDate) {
                updateCountdownTimer(shippingExpiresDate);
              }
            }
          }
        }

        setTimeout(() => {
          const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
          attachHoverListeners(dayElements);
        }, 0);


      },
      onMonthChange: function (date, instance) {
        setTimeout(() => {
          const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
          attachHoverListeners(dayElements);
        }, 0);
      },
      onYearChange: function (date, instance) {
        setTimeout(() => {
          const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
          attachHoverListeners(dayElements);
        }, 0);
      },
      onReady: function (selectedDates, dateStr, instance) {
        console.log('onReady', selectedDates);


        if (selectedDates && selectedDates.length === 2) {
          selectedOption.textContent = formatDateRange(selectedDates[0], selectedDates[1]);
          document.querySelector('.item--first-delivery-value').textContent = selectedOption.textContent;
          flowOBJ.first_delivery_window = selectedOption.textContent;
          const calendarShipDate = new Date(selectedDates[0]);
          // Find the Monday before the delivery date (which is 3 days before)
          const daysToMonday = ((calendarShipDate.getDay() + 7) - 1) % 7;
          calendarShipDate.setDate(calendarShipDate.getDate() - daysToMonday);
          const calendar_ship = formatYYYYMMDD(calendarShipDate);
          document.querySelector('.item--first-delivery-value').setAttribute('data-ship', calendar_ship);
          flowOBJ._SHIP = calendar_ship;
        }
        if (document.getElementById('countdown-timer')) {
          const shippingExpiresDate = new Date(firstValidRange.shipping_date_expires);
          if (shippingExpiresDate) {
            updateCountdownTimer(shippingExpiresDate);


          }
        }
      }
    });

    const calendarContainer = calendar.calendarContainer;
    if (calendarContainer) {
      const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');

      function attachHoverListeners(dayElements) {
        Array.from(dayElements).forEach(dayElem => {
          dayElem.removeEventListener('mouseover', handleDayHover);
          dayElem.addEventListener('mouseover', handleDayHover);
        });
      }

      function handleDayHover(e) {
        if (!e.target.classList.contains('flatpickr-disabled')) {
          const date = new Date(e.target.dateObj);

          // Clear all hover states first
          Array.from(dayElements).forEach(el => {
            el.classList.remove('hover-in-range');
            el.classList.remove('hover-startRange');
            el.classList.remove('hover-endRange');
          });

          // Find the matching date range for the hovered date
          const matchingRange = enableDates.find(range =>
            date >= range.from && date <= range.to
          );

          if (matchingRange) {
            Array.from(dayElements).forEach(el => {
              if (!el.classList.contains('flatpickr-disabled') &&
                !el.classList.contains('selected') &&
                !el.classList.contains('startRange') &&
                !el.classList.contains('endRange') &&
                !el.classList.contains('inRange')) {

                const elementDate = new Date(el.dateObj);

                // Compare dates ignoring time
                const isStartDate = elementDate.toDateString() === matchingRange.from.toDateString();
                const isEndDate = elementDate.toDateString() === new Date(matchingRange.to.getTime() - (23 * 60 * 60 * 1000 + 59 * 60 * 1000 + 59 * 1000)).toDateString();
                const isInRange = elementDate > matchingRange.from && elementDate < matchingRange.to && !isEndDate;

                if (isStartDate) {
                  el.classList.add('hover-startRange');
                } else if (isEndDate) {
                  el.classList.add('hover-endRange');
                } else if (isInRange) {
                  el.classList.add('hover-in-range');
                }
              }
            });
          }
        } else {
          // Clear hover states when hovering disabled dates
          Array.from(dayElements).forEach(el => {
            if (!el.classList.contains('selected') &&
              !el.classList.contains('startRange') &&
              !el.classList.contains('endRange') &&
              !el.classList.contains('inRange')) {
              el.classList.remove('hover-in-range');
              el.classList.remove('hover-startRange');
              el.classList.remove('hover-endRange');
            }
          });
        }
      }
      // Initial attachment of hover listeners
      attachHoverListeners(dayElements);

      // Add mouseleave handler to clear hover states
      calendarContainer.addEventListener('mouseleave', () => {
        Array.from(dayElements).forEach(el => {
          el.classList.remove('hover-in-range');
          el.classList.remove('hover-startRange');
          el.classList.remove('hover-endRange');
        });
      });
    }

  }

  function updateCountdownTimer(shippingExpiresDate) {
    const countdownTimer = document.getElementById('countdown-timer');
    if (!countdownTimer || !shippingExpiresDate) return;

    // Clear any existing interval
    if (countdownTimer.countdownInterval) {
      clearInterval(countdownTimer.countdownInterval);
    }

    // Store the interval ID on the element itself
    countdownTimer.countdownInterval = setInterval(() => {

      const now = new Date();
      const timeDiff = shippingExpiresDate.getTime() - now.getTime();

      // Check if time has expired
      if (timeDiff <= 0) {
        countdownTimer.innerHTML = 'Order deadline has passed';
        document.querySelector('[data-countdown-block]').classList.add('not-visible');
        clearInterval(countdownTimer.countdownInterval);
        return;
      }

      const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));

      if (hoursDiff <= 24) {
        document.querySelector('[data-countdown-block]').classList.remove('not-visible');

        if (hoursDiff >= 24) {
          // More than 24 hours - show day and time
          const dayOfWeek = shippingExpiresDate.toLocaleDateString('en-US', { weekday: 'long' });
          // Add 3 hours to account for timezone difference
          const adjustedDate = new Date(shippingExpiresDate.getTime() + (3 * 60 * 60 * 1000));
          const adjustedHours = adjustedDate.toLocaleTimeString('en-US', { hour: 'numeric' });
          countdownTimer.innerHTML = `Order by ${dayOfWeek} at ${adjustedHours} EST.`;
        } else {
          // Less than 24 hours - show live countdown
          const hours = Math.floor(timeDiff / (1000 * 60 * 60));
          const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

          countdownTimer.innerHTML = `Order within ${hours}hrs ${minutes}min.`;
        }
      } else {
        document.querySelector('[data-countdown-block]').classList.add('not-visible');
        countdownTimer.innerHTML = '';
        clearInterval(countdownTimer.countdownInterval);
      }
    }, 1000);
  }

  function formatYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }



  function formatDateRange(startDate, endDate) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    if (startDate.getMonth() === endDate.getMonth()) {
      // Same month format: "December  4 -  6"
      return `${months[startDate.getMonth()]}  ${startDate.getDate()} -  ${endDate.getDate()}`;
    } else {
      // Different months format: "December  31 - January  2"
      return `${months[startDate.getMonth()]}  ${startDate.getDate()} - ${months[endDate.getMonth()]}  ${endDate.getDate()}`;
    }
  }



  const quantityContainers = document.querySelectorAll('.purchase-flow-step__quantity-selector');

  quantityContainers.forEach(container => {
    const decreaseBtn = container.querySelector('.decrease');
    const increaseBtn = container.querySelector('.increase');
    const input = container.querySelector('input');

    decreaseBtn.addEventListener('click', () => updateQuantity(input, -1));
    increaseBtn.addEventListener('click', () => updateQuantity(input, 1));
    input.addEventListener('change', () => validateInput(input));

  });

  function updateQuantity(input, change) {
    let newValue = parseInt(input.value) + change;
    newValue = Math.max(parseInt(input.min), Math.min(parseInt(input.max), newValue));
    input.value = newValue;
    if (newValue === 0) {
      input.closest('.purchase-flow-step__quantity-selector').style.display = 'none';
      input.closest('.purchase-flow__product-card').classList.remove('active');
      input.closest('.purchase-flow__product-card').querySelector('[data-add-to-order]').style.display = 'block';
    }
  }

  function validateInput(input) {
    let value = parseInt(input.value);
    value = Math.max(parseInt(input.min), Math.min(parseInt(input.max), value));
    input.value = value;
  }

  const addToOrderButtons = document.querySelectorAll('[data-add-to-order]');

  addToOrderButtons.forEach(button => {
    button.addEventListener('click', function () {
      // console.log('addToOrder');
      button.style.display = 'none';
      button.closest('.purchase-flow__product-card').querySelector('.purchase-flow-step__quantity-selector').style.display = 'flex';
      button.closest('.purchase-flow__product-card').classList.add('active');
      button.closest('.purchase-flow__product-card').querySelector('.purchase-flow-step__quantity-selector input').value = 1;
    });
  });

  // document.getElementById('open-calendar-label').addEventListener('click', function() {
  //   const calendarContainer = document.getElementById('calendar-container');
  //   if (calendarContainer.style.maxHeight === '0px') {
  //     calendarContainer.style.maxHeight = calendarContainer.scrollHeight + 'px';
  //     calendar.open();
  //   } else {
  //     calendarContainer.style.maxHeight = '0px';
  //   }
  // });

  // Function to check if the user selected the 3rd product
  function userSelectedBuildYourOwnBox() {
    const box3VariantSelector = document.querySelector('input[name="box3-variant-selector"]:checked');
    // console.log('box3VariantSelector', box3VariantSelector);
    if (document.querySelector('.build-your-own-container') && box3VariantSelector && box3VariantSelector.closest('.purchase-flow-step_2__box').classList.contains('active')) {
      // console.log('userSelectedBuildYourOwnBox');
      document.querySelector('.build-your-own-container').classList.add('active');
      const boxSize = parseInt(box3VariantSelector.getAttribute('data-box-size'));
      byobQuantityChange(boxSize);
      // updatePreselectedProductsToggle(variantId);
      return true;
    } else {
      // console.log('userDidNotSelectBuildYourOwnBox');
      byobOBJ.status = false;
      if (document.querySelector('.build-your-own-container')) {
        document.querySelector('.build-your-own-container').classList.remove('active');
      }
      return false;
    }
  }

  const preselectedProductsToggle = document.querySelector('#preselected-products-toggle');
  if (preselectedProductsToggle) {
    preselectedProductsToggle.addEventListener('change', function () {
      const variantId = flowOBJ.box_variant_id;
      const boxSize = flowOBJ.boxSize;
      if (variantId) {
        updatePreselectedProductsToggle(variantId, boxSize);
      }
    });
  }

  // ===========================================================================
  // Dietary preference switching (standard / no-meat / no-nuts / no-crackers)
  // ===========================================================================

  // Build the "{sizeLetter}|{themeCode}" lookup key from a box SKU. Matches the
  // key format produced by snippets/purchase-byob-dietary-map.liquid.
  // e.g. "AHB-MCUST-MONG" -> "M|MONG", "AHB-LCUST-CORS-MONG" -> "L|MONG".
  function byobKeyFromSku(sku) {
    if (!sku) { return null; }
    const parts = String(sku).split('-');
    if (parts.length < 3) { return null; }
    const sizeLetter = parts[1].charAt(0);
    const themeCode = parts[parts.length - 1];
    return sizeLetter + '|' + themeCode;
  }

  // Resolve the currently selected size + dietary preference to the correct
  // product/variant/bundle, then rebuild frequency, reload bundle settings and
  // reapply that bundle's default item selections.
  async function applyActivePreference(showLoader) {
    const stdInput = document.querySelector('.purchase-flow-step_2__box-variants-selector__input:checked');
    if (!stdInput) { return; }

    if (showLoader) { showByobLoader(); }
    try {
      let pref = byobActivePreference || 'standard';
      const size = parseInt(stdInput.getAttribute('data-box-size')) || flowOBJ.boxSize;
      let targetId;
      let productId;
      let price;

      if (pref !== 'standard') {
        const key = byobKeyFromSku(stdInput.getAttribute('data-sku'));
        const map = window.byobPreferenceVariants && window.byobPreferenceVariants[pref];
        targetId = key && map ? map[key] : null;
        if (!targetId) {
          // No matching dietary variant for this size/theme — revert to standard.
          console.warn('[BYOB] No dietary variant for', pref, key, '- reverting to standard');
          pref = 'standard';
          byobActivePreference = 'standard';
          document.querySelectorAll('.byob-dietary-pill').forEach(function (b) {
            b.classList.toggle('is-selected', b.getAttribute('data-preference') === 'standard');
          });
        }
      }

      if (pref === 'standard') {
        targetId = parseInt(stdInput.value);
        price = stdInput.getAttribute('data-price');
        productId = (window.byobVariantMeta && byobVariantMeta[targetId] && byobVariantMeta[targetId].productId)
          || flowOBJ.box_product_id;
      } else {
        productId = byobVariantMeta[targetId].productId;
        price = byobVariantMeta[targetId].price;
      }

      flowOBJ.box_variant_id = parseInt(targetId);
      flowOBJ.box_product_id = parseInt(productId);
      flowOBJ.price = price;
      flowOBJ.boxSize = size;

      // Rebuild frequency options for the (possibly new) variant, then swap in the
      // matching bundle's settings so default selections come from the right bundle.
      updateFrequencyInfo(parseInt(targetId));
      await loadBundleSettings(productId);

      const toggle = document.querySelector('.preselected-products-toggle');
      if (toggle && toggle.checked) {
        updatePreselectedProductsToggle(parseInt(targetId), size);
      } else {
        byobQuantityChange(size);
      }
      updateBoxSummary();
    } finally {
      if (showLoader) { hideByobLoader(); }
    }
  }

  const dietaryPills = document.querySelectorAll('.byob-dietary-pill');
  if (dietaryPills.length) {
    dietaryPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        const pref = this.getAttribute('data-preference');
        if (pref === byobActivePreference) { return; }
        byobActivePreference = pref;
        dietaryPills.forEach(function (p) { p.classList.toggle('is-selected', p === pill); });
        applyActivePreference(true);
      });
    });
  }

  // ===========================================================================
  // Item progress pill ("X of Y items selected") + expandable box-summary panel
  // ===========================================================================
  const PREFERENCE_LABELS = {
    'standard': '',
    'no-meat': 'No Meat',
    'no-nuts': 'No Nuts',
    'no-crackers': 'No Crackers'
  };

  function updateBoxSummary() {
    const boxSize = parseInt(flowOBJ.boxSize) || 0;
    const quantityInputs = document.querySelectorAll('.byob-step--3 .purchase-flow__quantity-selector-input');
    const total = Array.from(quantityInputs).reduce(function (sum, input) {
      return sum + (parseInt(input.value) || 0);
    }, 0);

    const progressEl = document.getElementById('byob-summary-progress');
    if (progressEl) {
      progressEl.textContent = total + ' of ' + boxSize + ' item' + (boxSize === 1 ? '' : 's') + ' selected';
    }

    const fillEl = document.getElementById('byob-summary-bar-fill');
    if (fillEl) {
      const pct = boxSize > 0 ? Math.min(100, Math.round((total / boxSize) * 100)) : 0;
      fillEl.style.width = pct + '%';
      fillEl.classList.toggle('complete', boxSize > 0 && total >= boxSize);
    }

    // ---- Box summary panel contents ----

    // Delivery frequency (prefer the dropdown's displayed value).
    let frequency = '';
    const freqValueEl = document.querySelector('.byob-frequency-selector-dropdown__value');
    if (freqValueEl && freqValueEl.textContent.trim()) {
      frequency = freqValueEl.textContent.trim();
    } else if (flowOBJ.__freqName) {
      frequency = flowOBJ.__freqName.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }

    // Delivery window (from the calendar selection).
    let deliveryWindow = flowOBJ.first_delivery_window || '';
    if (!deliveryWindow) {
      const winEl = document.querySelector('.purchase-flow-step_3__plan-selection-delivery-dropdown-label');
      if (winEl && winEl.textContent.trim()) { deliveryWindow = winEl.textContent.trim(); }
    }

    const dietaryLabel = PREFERENCE_LABELS[byobActivePreference] || 'None';

    const detailsEl = document.getElementById('byob-summary-details');
    if (detailsEl) {
      const rows = [
        ['Size', boxSize ? boxSize + ' items' : ''],
        ['Price', flowOBJ.price || ''],
        ['Delivery frequency', frequency],
        ['Delivery window', deliveryWindow || 'Not selected'],
        ['Dietary preference', dietaryLabel]
      ];
      detailsEl.innerHTML = rows.map(function (r) {
        return '<div class="byob-summary-detail"><dt>' + r[0] + '</dt><dd>' + (r[1] || '—') + '</dd></div>';
      }).join('');
    }

    // Box items.
    const itemsEl = document.getElementById('byob-summary-items');
    if (itemsEl) {
      const activeCards = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card.active');
      if (!activeCards.length) {
        itemsEl.innerHTML = '<span class="byob-summary-empty">No items selected yet</span>';
      } else {
        itemsEl.innerHTML = Array.from(activeCards).map(function (card) {
          const titleEl = card.querySelector('.purchase-flow__product-title');
          const qtyEl = card.querySelector('.purchase-flow__quantity-selector-input');
          const imgEl = card.querySelector('.purchase-flow__product-card__image img');
          const title = titleEl ? titleEl.textContent.trim() : '';
          const qty = qtyEl ? qtyEl.value : '0';
          const src = imgEl ? (imgEl.getAttribute('src') || '') : '';
          return '<div class="byob-summary-row">'
            + (src ? '<img class="byob-summary-row__img" src="' + src + '" alt="" loading="lazy">' : '')
            + '<span class="byob-summary-row__qty">' + qty + '×</span>'
            + '<span class="byob-summary-row__name">' + title + '</span>'
            + '</div>';
        }).join('');
      }
    }

    // Offer item(s) — the free gift(s) that come with the box.
    const offerGroup = document.getElementById('byob-summary-offer-group');
    const offerEl = document.getElementById('byob-summary-offer');
    if (offerGroup && offerEl) {
      const gifts = document.querySelectorAll('input[name="free_gift_products"]');
      if (gifts.length) {
        offerEl.innerHTML = Array.from(gifts).map(function (g) {
          const t = g.getAttribute('data-title') || 'Free gift';
          return '<div class="byob-summary-row byob-summary-row--offer">'
            + '<span class="byob-summary-row__qty">1×</span>'
            + '<span class="byob-summary-row__name">' + t + '</span>'
            + '<span class="byob-summary-row__free">FREE</span>'
            + '</div>';
        }).join('');
        offerGroup.hidden = false;
      } else {
        offerGroup.hidden = true;
      }
    }
  }
  // Expose for handlers defined outside this closure scope.
  window.updateBoxSummary = updateBoxSummary;

  // Progress pill acts as a toggle for the box-summary panel (closed by default).
  const progressToggle = document.getElementById('byob-progress-toggle');
  const progressWrap = document.getElementById('byob-progress');
  if (progressToggle && progressWrap) {
    progressToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const open = progressWrap.classList.toggle('is-open');
      progressToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Close when clicking anywhere outside the pill/panel.
    document.addEventListener('click', function (e) {
      if (!progressWrap.contains(e.target)) {
        progressWrap.classList.remove('is-open');
        progressToggle.setAttribute('aria-expanded', 'false');
      }
    });
    // Dedicated close (×) button inside the panel.
    const progressClose = document.getElementById('byob-summary-close');
    if (progressClose) {
      progressClose.addEventListener('click', function (e) {
        e.stopPropagation();
        progressWrap.classList.remove('is-open');
        progressToggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function updatePreselectedProductsToggle(variantId, boxSize) {
    console.log('updatePreselectedProductsToggle', variantId);
    if (!byobOBJ.bundleSettings) {
      return;
    }
    console.log('bundleSettings', byobOBJ.bundleSettings);

    const variant = byobOBJ.bundleSettings.variants.find(variant => variantId === parseInt(variant.external_variant_id));
    // console.log('variant', variant);
    if (!variant || !variant.selection_defaults || variant.selection_defaults.length <= 0) {
      return;
    }
    console.log('variants', variant);
    const quantityInputs = document.querySelectorAll('.byob-step--3 .purchase-flow__quantity-selector-input');
    quantityInputs.forEach(input => {
      input.value = 0;
      input.parentElement.style.display = 'none';
      // console.log('input.parentElement', input.parentElement);
      input.parentElement.closest('.purchase-flow__product-card').querySelector('.purchase-flow__product-card__button').style.display = 'block';
      // input.closest('.purchase-flow__quantity-selector').style.display = 'none';
    });
    if (preselectedProductsToggle.checked) {
      const activeProductCards = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card.active');
      activeProductCards.forEach(productCard => {
        productCard.classList.remove('active');
      });
      // console.log('preselectedProductsToggle is checked');
      const preselectedProducts = variant.selection_defaults;
      preselectedProducts.forEach(product => {
        // console.log('product.variants[0].id', product.variants[0].id);
        // console.log('variant_id', product.external_variant_id);
        const productCardButton = document.querySelector(`.purchase-flow__product-card:not(.purchase-flow__product-card--unavailable) [data-variant-id="${parseInt(product.external_variant_id)}"]`);
        if (!productCardButton) {
          console.log('productCardButton not found', product.external_variant_id);
          return;
        }
        const productCard = productCardButton.closest('.purchase-flow__product-card');
        // console.log('productCard', productCard);
        if (productCard) {
          const productQtyInput = productCard.querySelector('.purchase-flow__quantity-selector-input');
          // console.log('productQtyInput before', productQtyInput);
          productCardButton.dispatchEvent(new Event('click'));
          if (productQtyInput) {
            productQtyInput.value = product.quantity;
          }

        }
      });
    } else {
      const activeProductCards = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card.active');
      activeProductCards.forEach(productCard => {
        productCard.classList.remove('active');
      });
      // console.log('preselectedProductsToggle is not checked');
    }
    byobQuantityChange(boxSize);
  }

  function byobQuantityChange(boxSize) {
    footerContinueButton.textContent = `Add ${boxSize} more item${boxSize !== 1 ? 's' : ''}`;
    const quantityInputs = document.querySelectorAll('.byob-step--3 .purchase-flow__quantity-selector-input');
    const decreaseButtons = document.querySelectorAll('.byob-step--3 .decrease');
    const increaseButtons = document.querySelectorAll('.byob-step--3 .increase');
    const addToOrderButtons = document.querySelectorAll('.byob-step--3 [data-add-to-order]');
    const productCards = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card');
    const activeTotalQuantity = Array.from(quantityInputs).reduce((sum, input) => sum + parseInt(input.value), 0);

    if (activeTotalQuantity > boxSize) {
      quantityInputs.forEach(input => {
        input.value = 0;
      });
    }




    function updateButtonState() {
      const totalQuantity = Array.from(quantityInputs).reduce((sum, input) => sum + parseInt(input.value), 0);
      if (totalQuantity >= boxSize) {
        footerContinueButton.disabled = false;
        footerContinueButton.textContent = byob_flow_settings.footer_continue_text_popup_disabled;

        if (popupShow == 'true') {
          footerContinueButton.textContent = byob_flow_settings.footer_continue_text_popup_enabled;
        }
        footerContinueButton.addEventListener('click', function () {
          addBYOBtoArray();
        });
        addToOrderButtons.forEach(button => {
          button.disabled = true;
        });
        productCards.forEach(card => {
          if (!card.classList.contains('active')) {
            card.classList.add('disabled');
          }
        });
        increaseButtons.forEach(button => {
          button.disabled = true;
        });


      } else {

        increaseButtons.forEach(button => {
          button.disabled = false;
        });
        addToOrderButtons.forEach(button => {
          button.disabled = false;
        });
        productCards.forEach(card => {
          card.classList.remove('disabled');
        });
        footerContinueButton.disabled = true;
        footerContinueButton.textContent = `Add ${boxSize - totalQuantity} more item${boxSize - totalQuantity !== 1 ? 's' : ''} →`;
      }
      updateBoxSummary();
    }

    addToOrderButtons.forEach(button => {
      button.addEventListener('click', () => {
        // console.log('byob add to order');
        updateButtonState();
      });
    });

    decreaseButtons.forEach(button => {
      button.addEventListener('click', () => {
        // console.log('byob decrease');
        updateButtonState();
      });
    });

    increaseButtons.forEach(button => {
      button.addEventListener('click', () => {
        // console.log('byob increase');
        updateButtonState();
      });
    });

    quantityInputs.forEach(input => {
      input.addEventListener('change', () => {
        // console.log('byob input change');
        updateButtonState();
      });
    });

    // Initial update
    updateButtonState();
  }

  function addBYOBtoArray() {
    byobOBJ.products = [];
    const activeBYOBProducts = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card.active');

    if (activeBYOBProducts.length > 0) {
      byobOBJ.status = true;
      activeBYOBProducts.forEach(product => {
        const productName = product.querySelector('.purchase-flow__product-title').textContent.trim();
        const productID = parseInt(product.querySelector('.purchase-flow__product-card__button').getAttribute('data-product-id'));
        const variantID = parseInt(product.querySelector('.purchase-flow__product-card__button').getAttribute('data-variant-id'));
        const collectionID = parseInt(product.querySelector('.purchase-flow__product-card__button').getAttribute('data-collection-id'));
        const quantity = product.querySelector('.purchase-flow__quantity-selector-input').value;
        byobOBJ.products.push({ product_name: productName, quantity: parseInt(quantity), product_id: productID, variant_id: variantID, collection_id: collectionID });
      });

    }

    // console.log('byobOBJ', byobOBJ);
  }



  // Build your own box Collections Filter
  const byobCollectionsFilterButtons = document.querySelectorAll('.byob-step--3 .purchase-flow__collections-filter-button');
  const byobCollections = document.querySelectorAll('.byob-step--3 .purchase-flow__collection');
  const byobCollectionsFilterDropdown = document.querySelectorAll('.byob-step--3 .purchase-flow__collections-filter-buttons.mobile .purchase-flow-dropdown');

  byobCollectionsFilterDropdown.forEach(dropdown => {
    dropdown.addEventListener('change', () => {
      // console.log('byob collection filter dropdown');
      byobCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      const dataCollection = dropdown.value;
      // console.log('dataCollection', dataCollection);
      if (dataCollection === 'all') {
        byobCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--3 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      dropdown.classList.add('active');
    });
  });

  byobCollectionsFilterButtons.forEach(button => {
    button.addEventListener('click', () => {
      // console.log('byob collection filter button');
      byobCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      byobCollectionsFilterButtons.forEach(button => {
        button.classList.remove('active');
      });
      const dataCollection = button.getAttribute('data-collection');
      if (dataCollection === 'all') {
        byobCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--3 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      button.classList.add('active');
    });
  });

  // add Extras filter
  const extrasCollectionsFilterButtons = document.querySelectorAll('.byob-step--4 .purchase-flow__collections-filter-button');
  const extrasCollections = document.querySelectorAll('.byob-step--4 .purchase-flow__collection');
  const extrasCollectionsFilterDropdown = document.querySelectorAll('.byob-step--4 .purchase-flow__collections-filter-buttons.mobile .purchase-flow-dropdown');

  extrasCollectionsFilterDropdown.forEach(dropdown => {
    dropdown.addEventListener('change', () => {
      // console.log('extras collection filter dropdown');
      extrasCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      const dataCollection = dropdown.value;
      // console.log('dataCollection', dataCollection);
      if (dataCollection === 'all') {
        extrasCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--4 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      dropdown.classList.add('active');
    });
  });

  extrasCollectionsFilterButtons.forEach(button => {
    button.addEventListener('click', () => {
      // console.log('extras collection filter button');
      extrasCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      extrasCollectionsFilterButtons.forEach(button => {
        button.classList.remove('active');
      });
      const dataCollection = button.getAttribute('data-collection');
      if (dataCollection === 'all') {
        extrasCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--4 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      button.classList.add('active');
    });
  });

  // Product More Info popup (gallery, carousel and zoom) is handled by the
  // shared product-info-popup.js via delegated handlers on the card markup.



  function calculateNextBillingDate(shipDate, frequencyLabel) {
    // if no selling plan, return null
    if (product_1.sellingPlanGroups.length === 0) return null;
    // If gift is selected, return null
    if (document.querySelector('#subscriptionGift') && document.querySelector('#subscriptionGift').checked) return null;

    const today = new Date();
    const date = new Date(shipDate + 'T00:00:00');

    // Check if selected date is at least 7 days from today
    const minimumDate = new Date(today);
    minimumDate.setDate(today.getDate() + 7);

    if (date < minimumDate) {
      return null;
    }


    const matches = frequencyLabel.match(/every (\d+) (month|weeks)/i);
    if (!matches) return shipDate;

    const [_, number, unit] = matches;

    if (unit.toLowerCase() === 'month') {
      date.setMonth(date.getMonth() + parseInt(number));
    } else if (unit.toLowerCase() === 'weeks') {
      date.setDate(date.getDate() + (parseInt(number) * 7));
    }

    return formatYYYYMMDD(date);
  }
  function addToBundle() {
    if (!flowOBJ || !flowOBJ.box_variant_id || !flowOBJ.selling_plan_id) {
      console.error('Invalid flowOBJ:', flowOBJ);
      return;
    }
    // Before getting rbId, create the bundle object
    const bundle = {
      externalVariantId: flowOBJ.box_variant_id,
      externalProductId: flowOBJ.box_product_id,
      selections: byobOBJ.products.map(product => ({
        collectionId: product.collection_id,
        externalProductId: product.product_id,
        externalVariantId: product.variant_id,
        quantity: product.quantity
      }))
    };
    getBundleId(bundle);
  }

  // Add event listener for when bundle ID is received
  document.addEventListener('bundleIdReceived', function () {
    addToCart();
  });

  function addToCart() {
    if (!flowOBJ || !flowOBJ.box_variant_id || !flowOBJ.selling_plan_id) {
      console.error('Invalid flowOBJ:', flowOBJ);
      return;
    }

    // First, clear the cart
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(() => {
        console.log('Cart cleared successfully');

        let items = [];


        // free gift products
        const freeGiftProducts = document.querySelectorAll('input[name="free_gift_products"]');
        if (freeGiftProducts) {
          freeGiftProducts.forEach(product => {
            items.push({ id: parseInt(product.value), quantity: 1, parent_id: flowOBJ.box_variant_id });
          });
        }

        // Add extras as one-time purchases
        if (flowOBJ.extras && flowOBJ.extras.length > 0) {
          flowOBJ.extras.forEach(extra => {
            items.push({
              id: extra.product_id,
              quantity: extra.quantity,
              parent_id: flowOBJ.box_variant_id,
              properties: {
                "Type": "Extra Item",
              }
            });
          });
        }


        const frequencyLabel = document.querySelector('.frequency-selector input[type="radio"]:checked')
          ? document.querySelector('.frequency-selector input[type="radio"]:checked').nextElementSibling.textContent.trim()
          : '';
        const nextBillingDate = flowOBJ.selling_plan_id && flowOBJ._SHIP != '' && flowOBJ._SHIP != null && frequencyLabel != '' ? calculateNextBillingDate(flowOBJ._SHIP, frequencyLabel) : null;
        // Now add the new items
        items.push({
          id: flowOBJ.box_variant_id,
          quantity: 1,
          selling_plan: flowOBJ.selling_plan_id,
          properties: {
            '_rb_id': flowOBJ.rbId,
            'Box Contents': byobOBJ.products.map((product, index, array) =>
              `${product.quantity}x ${product.product_name}${index === array.length - 1 ? '' : ', '}`
            ).join('\n'),
            'First Delivery Window': flowOBJ.first_delivery_window,
            '_SHIP': flowOBJ._SHIP,
            '_NEXT_BILLING_DATE': nextBillingDate
          }
        });


        // console.log('items', items);
        // return;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });
      })
      .then(response => response.json())
      .then(data => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
            // console.log('Raw cart data:', cartData);

            // Format cart data for Klaviyo
            var cart = {
              $value: cartData.total_price / 100, // Total value in dollars
              ItemNames: cartData.items.map(item => item.title),
              Items: cartData.items.map(item => ({
                ProductID: item.product_id,
                SKU: item.sku,
                ProductName: item.title,
                Quantity: item.quantity,
                ItemPrice: item.price / 100,
                RowTotal: (item.price * item.quantity) / 100,
                ProductURL: window.location.origin + item.url,
                ImageURL: item.image,
                ProductCategories: item.product_type ? [item.product_type] : []
              }))
            };

            // console.log('Formatted cart data for Klaviyo:', cart);
            // if (popupShow === 'true') {
            //   checkoutButton.textContent = 'Checkout →';
            //   checkoutButton.removeAttribute('disabled');
            // } else {
            //   footerContinueButton.textContent = 'Continue →';
            //   footerContinueButton.removeAttribute('disabled');
            // }
            _learnq.push(['track', 'Added to Cart', cart]);
            // console.log('Klaviyo push completed');

            // You might want to redirect or update UI here

            window.location.href = '/checkout';
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
          });
      })
      .catch(error => {
        console.error('Error clearing cart or adding items:', error);
      });
  }



  const boxSize = getQueryParams('box-size');
  const boxFrequency = getQueryParams('frequency');
  // console.log('boxSize', boxSize);
  // console.log('boxFrequency', boxFrequency);
  if (boxSize) {
    if (boxSize.includes('Large')) {
      BoxVariants[1] ? BoxVariants[1].click() : null;
      BoxVariants[1] ? BoxVariants[1].dispatchEvent(new Event('change', { bubbles: true })) : null;
    } else {
      // Select the first box by default
      if (BoxVariants.length > 0) {
        // console.log('BoxVariants clicked');
        BoxVariants[0] ? BoxVariants[0].click() : null;
        BoxVariants[0] ? BoxVariants[0].dispatchEvent(new Event('change', { bubbles: true })) : null;
      }
    }
    updatePreselectedProductsToggle(flowOBJ.box_variant_id, flowOBJ.boxSize);
  } else {
    // Select the first box by default
    if (BoxVariants.length > 0) {
      // console.log('BoxVariants clicked');
      BoxVariants[0] ? BoxVariants[0].click() : null;
      BoxVariants[0] ? BoxVariants[0].dispatchEvent(new Event('change', { bubbles: true })) : null;
    }
  }
  if (boxFrequency) {
    const frequencyLabels = document.querySelectorAll('.frequency-selector__option');
    console.log('frequencyLabels', frequencyLabels);
    frequencyLabels.forEach(label => {
      console.log('label', label.textContent.toLowerCase());
      if (label.textContent.toLowerCase().includes(boxFrequency.toLowerCase())) {
        label.click();
        // label.dispatchEvent(new Event('click', { bubbles: true }));
        // label.dispatchEvent(new Event('change', { bubbles: true }));

      }
    });
  }
  // Function to update collection titles dynamically in Step 3
  function updateCollectionTitles(boxSize) {
    const collectionTitles = document.querySelectorAll('.byob-step--3 .purchase-flow__collection-title');
    if (collectionTitles.length > 0) {
      const firstPick = Math.max(boxSize - 4, 4); // Ensure at least "Pick 4"
      const secondPick = 4; // Always "Pick 4"

      // Update collection titles dynamically
      collectionTitles[0].textContent = collectionTitles[0].dataset.originalTitle + ` (Pick ${firstPick})`;
      if (collectionTitles.length > 1) {
        collectionTitles[1].textContent = collectionTitles[1].dataset.originalTitle + ` (Pick ${secondPick})`;
      }
    }
  }

  // Store original collection titles to prevent duplication
  // document.querySelectorAll('.byob-step--3 .purchase-flow__collection-title').forEach(title => {
  //   title.dataset.originalTitle = title.textContent.trim();
  // });

  // // Set default collection titles based on initially selected variant
  // const initialVariant = document.querySelector('.purchase-flow-step_2__box-variants-selector__input:checked');
  // if (initialVariant) {
  //   updateCollectionTitles(parseInt(initialVariant.getAttribute('data-box-size')));
  // }

  // // Listen for changes in bundle size selection
  // document.querySelectorAll('.purchase-flow-step_2__box-variants-selector__input').forEach(variant => {
  //   variant.addEventListener('change', function () {
  //     updateCollectionTitles(parseInt(this.getAttribute('data-box-size')));
  //   });
  // });


  // Listen for changes in bundle size selection

  const bundlePageBoxOptions = document.querySelectorAll('.js-bundle-page-box-option-input');
  if (bundlePageBoxOptions.length > 0) {
    bundlePageBoxOptions.forEach(option => {
      option.addEventListener('change', function () {

        const variantType = this.getAttribute('data-variant-type');
        const activeBoxSize = document.querySelector('.purchase-flow-step_2__box-variants-selector__input:checked').getAttribute('data-box-size');
        console.log('activeBoxSize', activeBoxSize);
        const step1VariantsSelectors = document.querySelectorAll('.purchase-flow-step_2__box-variants-selectors [data-variant-type]');
        if (step1VariantsSelectors.length > 0) {
          step1VariantsSelectors.forEach(selector => {
            if (selector.getAttribute('data-variant-type') === variantType) {
              selector.classList.add('active');
              selector.classList.remove('hidden');
            } else {
              selector.classList.remove('active');
              selector.classList.add('hidden');
            }
          });
        }
        const defaultCallOut = document.querySelector('.purchase-flow__call-outs[data-variant-type="default"]');
        const allCallOuts = document.querySelectorAll('.purchase-flow__call-outs');
        const boxCallOuts = document.querySelectorAll('.purchase-flow__call-outs[data-variant-type="' + variantType + '"]');
        if (boxCallOuts.length > 0) {
          allCallOuts.forEach(callOut => {
            callOut.classList.add('hidden');
          });
          boxCallOuts.forEach(callOut => {
            callOut.classList.remove('hidden');
            if (defaultCallOut) {
              defaultCallOut.classList.add('hidden');
            }
          });
        } else {
          if (defaultCallOut) {
            defaultCallOut.classList.remove('hidden');
          }
        }
        const updatedStep1VariantSelector = document.querySelector('.active .purchase-flow-step_2__box-variants-selector__input[data-box-size="' + activeBoxSize + '"]');
        if (updatedStep1VariantSelector) {
          updatedStep1VariantSelector.checked = true;
          updatedStep1VariantSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }


});


